<template>
  <v-flex>
    <v-layout row wrap fluid>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Documents</h2>
        <p>Setup of a template level document structure</p>
        <template v-if="isAppAdmin">
          <p>
            Search indexes the text of files attached to cases of this template.
            Use <strong>Reindex Documents</strong> to extract text from existing files and add them to search.
          </p>
          <v-btn color="primary" class="ml-0 mt-1 mb-4" dark @click="$emit('reindex-documents')">
            Reindex Documents
          </v-btn>
        </template>
      </v-flex>
      <v-flex
        style="width: calc(100% - 180px); display: block !important;"
        :class="{'tabs-shift-right': $vuetify.breakpoint.smAndDown}"
      >
        <DocumentsTable
          :documentHeaders="docsHeader"
          :isConfigMode="true"
        ></DocumentsTable>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import DocumentsTable from "@/components/documents/DocumentsTable.vue"
import { mapState } from "vuex"

export default {
  name: "CaseConfigDocuments",
  components: {
    DocumentsTable
  },
  props: { caseType: { type: Object, required: true } },
  data() {
    return {
      docsHeader: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Type', value: 'modified' }
      ]
    }
  },
  computed: {
    ...mapState({
      isAccountAdmin: state => state.currentUser && state.currentUser.isAccountAdmin
    }),
    isAppAdmin() {
      return !!this.isAccountAdmin
    }
  }
}
</script>

<style>
</style>
